import {useEffect} from "react";
import {Container, Stack, Typography, Box} from '@mui/material';
import EstablishmentList from "../establishment/EstablishmentList";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const Professional = ({setShowNav}) => {
    useEffect(() => {
        setShowNav(true);
    }, []);
    const {mode} = useDarkMode();
    return (
        <div style={{backgroundColor:mode.settings.backgroundColor2}}>
            <Container className={"container"}>
                <Stack direction={"column"} alignItems={"center"} spacing={5} sx={{paddingTop:5}}>
                    <Typography variant={"h2"} color={"#C72B5C"} sx={{marginTop : '20px !important', marginBottom : '20px !important'}}>Je suis un professionnel de santé</Typography>
                    <Typography variant={"subtitle3"} sx={{textAlign : 'justify', color : mode.settings.textColor3}} >
                        La plateforme OHS Solutions est un service de l'Office d’Hygiène Sociale de Lorraine. L’OHS de Lorraine, association
                        reconnue d’utilité publique, a été fondée par le Doyen PARISOT en 1920. Elle propose des accompagnements «sur mesure»
                        en Moselle, Meuse et Meurthe-et-Moselle auprès des personnes rendues vulnérables par l’avancée en âge, le handicap ou la
                        fragilité sociale.
                    </Typography>
                    <Typography variant={"subtitle3"} sx={{textAlign : 'justify', color : mode.settings.textColor3}}>
                        Acteur incontournable des champs sociaux, médico-sociaux et sanitaires dans le Grand Est, adhérent FEHAP, c’est en appui
                        sur les 55 établissements et services sur les territoires que l’OHS de Lorraine développe des partenariats agiles et innovants
                        au service de celles et ceux qui en ont besoin.
                    </Typography>
                </Stack>
                <EstablishmentList/>
            </Container>

        </div>
    )
}

export default Professional;
